module.exports = ".navbar-right {\n  margin: 8px 0px 8px 0px; }\n\np.btn {\n  background: transparent;\n  color: #777; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/globalnav/globalnav.component.scss
// module id = 1176
// module chunks = 1